namespace GeniuzPOS.AdvPromo {
    export namespace Adv05ItemExDtService {
        export const baseUrl = 'AdvPromo/Adv05ItemExDt';

        export declare function Create(request: Serenity.SaveRequest<Adv05ItemExDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Adv05ItemExDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Adv05ItemExDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Adv05ItemExDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/Adv05ItemExDt/Create",
            Update = "AdvPromo/Adv05ItemExDt/Update",
            Delete = "AdvPromo/Adv05ItemExDt/Delete",
            Retrieve = "AdvPromo/Adv05ItemExDt/Retrieve",
            List = "AdvPromo/Adv05ItemExDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Adv05ItemExDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
